<template>
  <div class="device">

    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow mb-1">
          <div class="card-header py-3 d-flex flex-row justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">{{txt('Send Messages')}}</h6>
          </div>
          <div class="card-body" style="padding:15px;font-size:13px" id="no-more-tables">
            <div class="row">
              <div class="col-lg-4 col-md-12 col-xs-12 text-center">
                <img src="../../assets/images/messageIcon.png" style="height:100px" />
              </div>
              <div class="col-lg-8 col-md-12 col-xs-12">
                <div class="row">
                
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="channel">
                        {{txt('Channel')}}
                        <span>*</span>
                      </label>
                      <select class="form-control" v-model="channel" required>
                        <option>{{txt('Select channel')}}</option>
                        <option
                          v-for="channel in channels"
                          v-bind:value="channel"
                          :key="channel.value"
                        >{{channel.label.toUpperCase()}}</option>
                      </select>
                    </div>
                  </div>
                  <!-- end 12  -->
                  
                  <div class="col-md-12" v-if="channel.value === 'whatsapp'">
                    <div class="form-group">
                      <label for="device">
                        {{txt('Device')}}
                      </label>
                      <select class="form-control" v-model="device" required>
                        <option>{{txt('Select device')}}</option>
                        <option
                          v-for="device in devices"
                          v-bind:value="device.phoneNumber"
                          :key="device._id"
                          :serializer="s => s.phone"
                        >{{device.phoneNumber}}</option>
                      </select>
                    </div>
                  </div>
                  <!-- end 12  -->

                </div>

                <!-- target -->
                <div class="row">
                  <div class="col-md-12">
                    <label>{{txt('Target')}}</label>
                    
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">

                          <div class="form-check">
                            <input class="form-check-input" type="radio" value="send" v-model="sendMethod" id="defaultCheck1">
                            <label class="form-check-label" for="defaultCheck1">
                              {{txt('Phone')}}
                            </label>
                          </div>

                          <div class="form-check">
                            <input class="form-check-input" type="radio" value="csvSend" v-model="sendMethod" id="defaultCheck2">
                            <label class="form-check-label" for="defaultCheck2">
                              {{txt('Send via CSV')}}
                            </label>
                          </div>

                          <!-- sendMethod: {{sendMethod}} -->
                            
                        </div>
                      </div>
                      <!-- end col-md-6 -->
                      
                      <div class="col-md-6" v-if="sendMethod === 'send'">
                        <div class="form-group">
                          <label for>{{txt('Phone Number')}}
                            <!-- 1. {{targetNumber}}
                            <br>
                            2. {{searchPhone}} -->
                          </label>
                          <vue-bootstrap-typeahead
                            v-model="searchPhone"
                            :data="contacts"
                            :serializer="s => s.phone"
                            @hit="onPhoneSelected"
                            placeholder="+85266668888"
                          ></vue-bootstrap-typeahead>
                          <!-- <input
                            type="text"
                            class="form-control"
                            required
                            v-model="targetNumber"
                            placeholder="+85212345678"
                          /> -->
                        </div>
                      </div>
                      <!-- end 6 -->

                      <div class="col-md-6" v-if="sendMethod === 'csvSend'">
                        <div class="form-group">
                          <div class="form-group">
                            <input class="form-control" type="file" accept=".csv" id="file" ref="file" v-on:change="handleFileUpload()"/>
                            <p>
                              <!-- <a href="https://docs.google.com/spreadsheets/d/1DCf9SI4nU6jYYNXJzJV1VL3LaOhMSVkFh6HsKvDvV2M/edit?usp=sharing" target="_blank">{{txt('Download sample CSV')}}</a> -->
                              <a href="https://supermeteor.s3-ap-southeast-1.amazonaws.com/public/supermeteor_batch_messages_sample.csv" target="_blank">{{txt('Download sample CSV')}}</a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- end 6 -->

                    </div>
                    <!-- end inner row -->

                  </div>
                  <!-- end 12 -->
                  
                  
                </div>
                <!-- end target -->
                
                <div class="row" v-if="sendMethod === 'send'">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="message">{{txt('Message')}}</label>
                      <textarea
                        class="form-control"
                        v-model="messageText"
                        required
                        rows="5"
                        id="message"
                        :placeholder="txt('Type message...')"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="channel === 'whatsapp'">
                  <div class="col-md-12">
                    <div>
                      <label>
                        {{txt(`Recomended max 300 characters`)}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-primary w-10" @click="sendMessage()" :disabled="sending">
                      <i class="far fa-paper-plane"></i>
                      {{txt('Send message')}}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="alert alert-danger"
                    v-if="sendError"
                  >{{getSendErrorMessage(sendError)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow mb-1">
          <div class="card-header py-3 d-flex flex-row justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">{{txt('Result')}}</h6>
          </div>
          <div class="card-body" style="padding:15px;font-size:13px" id="no-more-tables">
            <div class="row">
              <div class="table-responsive msg">
                <button class="btn btn-md btn-warning" @click="csvExport()">{{txt('Export CSV')}}</button>
                <b-table ref="table" :items="getResult"></b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import toast from "../../services/toast";
import store from "../../store/store";
import { first, get, size, filter, debounce, map,
  omit, } from "lodash";
import "vue-bootstrap-typeahead/dist/VueBootstrapTypeahead.css";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
// import VueSuggestion from 'vue-suggestion'

export default {
  components: {
    // VueSuggestion
    VueBootstrapTypeahead,
  },
  name: "sendMessage",
  beforeRouteEnter: function (to, from, next) {
    next((vm) => {
      // const app = vm;
      // vm.getDevices();
    });
  },

  async created() {
    this.loadDevices();
    // load profile
    let {data: profile} = await this.axios.get("/account/me/profile")
    this.profile = profile

    // check if has dedicatedPhones in setting.sms.dedicatedPhones
    // then add channels
    if (get(this.profile, 'setting.sms.dedicatedPhones', []).length){
      _.map(this.profile.setting.sms.dedicatedPhones, (phone) => {
        this.channels.push({
          label: `SMS Dedicated - ${phone}`,
          value: `sms-dedicated`,
          channel: 'sms',
          phone,
        })
      })


      // console.log(this.channels)
    }

    // assign channel to first item
    this.channel = first(this.channels, {})

  },

  data() {
    return {
      profile: null,
      sendError: null,
      sending: false,
      channel: {},
      channels: [
        {
          label: "SMS",
          value: "sms",
          channel: 'sms',
        },
        {
          label: "Whatsapp",
          value: "whatsapp",
          channel: 'whatsapp',
        }, 
      ],
      messages: [],
      devices: [],
      device: "",
      messageText: "",

      sendMethod: 'send', // csvSend|send
      targetNumber: "",
      contacts: [],
      selectedPhone: null,
      searchPhone: null,
      file: null,

      result: null,
    };
  },
  watch: {
    searchPhone: debounce(function (searchTerm) {
      // console.log('----sear ch phone X', {searchTerm})

      this.targetNumber = searchTerm
      return this.getPhones(searchTerm);
    }, 200),
  },
  methods: {
    csvExport() {
      let csvContent = "data:text/csv;charset=utf-8,";
      let arrData = map(this.result, r => {
        return omit(r.message, [
          'test'
        ])
      })

      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map(item => Object.values(item).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    getResult(){
      if (!size(this.result)){
        return [
          {
            "NO RESULT": ""
          }
        ]
      }
      return map(this.result, r => {
        return omit(r.message, [
          'test'
        ])
      })
    },
    handleFileUpload(){
      this.file = this.$refs.file.files[0]
      // console.log(
      //   this.file
      // )
    },
    onPhoneSelected($event){
      console.log({$event})
      this.targetNumber = $event.phone
    },
    async getPhones(searchTerm) {
      // console.log("get phhones");

      if (size(searchTerm) < 3){
        return
      }
      
      let params = {
        keyword: searchTerm,
      };
      let { data } = await this.axios.get(
        `/account/${store.getters.accountID}/contacts`,
        {
          params,
        }
      );
      this.contacts = data.contacts;
    },
    async loadDevices() {
      const self = this;
      try {
        let { data: {devices} } = await this.axios.get("/devices");
        // console.log({devices})
        self.devices = filter(devices, (r) => r.status === "RUNNING");

        if (size(self.devices) && !self.device) {
          self.device = _.get(first(self.devices), "phoneNumber");
          console.log(self.device);
        }
      } catch (err) {
        toast.error(err.response.data.message);
      }
    },
    getSendErrorMessage(error) {
      return get(error, "response.data.message", error.message);
    },
    onDeviceChange(device) {
      console.log(device);
    },
    async sendMessage() {
      const vm = this;

      let data = {
        secret: store.getters.secret,
        // fromPhone: vm.device,
        phone: vm.targetNumber,
        message: vm.messageText,
      };

      this.sending = true;
      this.sendError = null;
      try {
        // check country
        if (this.sendMethod === 'send'){
          if (this.device == "" && this.channel.value === "whatsapp") {
            throw new Error("Field required: Please select device.");
          }
          if (this.targetNumber == "") {
            throw new Error("Field required: Please enter target phone number.");
          }
          if (this.messageText == "") {
            throw new Error("Field required: Message should not be empty.");
          }
        }

        if (this.sendMethod === 'csvSend'){
          // TODO validate file extension
          if (!this.file) {
            throw new Error("Missing attachment");
          }
        }
        
        let opts = {}

        let formData = new FormData()
        formData.append('csv', this.file)
        formData.append('secret', store.getters.secret)

        if (this.channel.channel === 'whatsapp'){
          formData.append('fromPhone', vm.device)
          data.fromPhone = vm.device
        }

        if (this.channel.value === 'sms-dedicated'){
          formData.append('fromPhone', this.channel.phone)
          data.fromPhone = this.channel.phone
        }

        let apiurl = `/${this.channel.channel}/send`
        if (this.sendMethod === 'csvSend'){
          apiurl = `/${this.channel.channel}/csvSend`
          opts.header = {
            'content-type': 'multipart/form-data',
          }
          data = formData
        }
        else {
          // single
          // data['test'] = true // TODO remove test mode
        }

        // TODO remove test mode
        // formData.append('test', true)
// console.log({
//   channel: this.channel,
//   data, 
//   formData
// })
        setTimeout(() => {
          this.sending = false;
        }, 5 * 1000)
        
        let {data: result} = await this.axios.post(apiurl, data, opts);
        if (this.sendMethod === 'send'){
          result = [result]
        }

        this.result = result

        this.$refs.table.refresh();

        toast.success("Message send succesfully.");
      } catch (error) {
        // console.log({error})
        this.sendError = error;
        toast.error(this.getSendErrorMessage(error));
      }

      this.sending = false;
    },
  },
};
</script>